export default __webpack_public_path__ + "static/media/kanelbulle.54741aa0.jpg";